import { useState, useCallback, useEffect } from 'react';
import { Link } from 'react-router-dom';

import classes from './styles.module.css';
import { Menu, XMark } from 'src/components/icons';



import logo_ar from "src/assets/images/nav_logo_ar.svg";
import logo_en from "src/assets/images/nav_logo_en.svg";

import { useTranslation } from 'react-i18next';
import { LanguageMenuLg, LanguageMenuSm } from 'src/components/langMenu';
import { isRTL } from 'src/utils/global';


const navItems = [
    { name: 'nav.home', path: '/' },
    { name: 'nav.services', path: '/services' },
    { name: 'nav.about', path: '/about' },
    { name: 'nav.easy', path: '/electronic-advanced-system' },
    { name: 'nav.contact', path: '/contact' },
]


const Nav = () => {
    const { t, i18n } = useTranslation(['common']);
    const [width, setWidth] = useState<number>(0);
    const [showMenu, setShowMenu] = useState(false);

    const closeMenuHandle = useCallback(() => {
        setShowMenu(false)
    }, [])

    const getWidth = useCallback((hasWindow: boolean) => {
        const width = hasWindow ? window.innerWidth : 0;
        return width
    }, [window.innerWidth]);


    useEffect(() => {
        const hasWindow = typeof window !== 'undefined';
        setWidth(getWidth(hasWindow));

        if (hasWindow) {
            const handleResize = () => {
                setWidth(getWidth(hasWindow));
            }
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }
    }, []);

    return (<header className={`${classes.header}`}>
        <nav className={`${classes.nav} container-fluid`}>
            <div className={classes.nav__data}>
                <a href="/" className={classes.nav__logo}>
                    <img src={isRTL() ? logo_ar : logo_en} alt={"..."}
                        loading='lazy'
                    />
                </a>

                <div className={`${classes.nav__toggle} ${showMenu ? classes.show__icon : ''} `} >
                    <Menu className={`${classes.nav__burger} ${showMenu ? classes.hide__burger__icon : ''} `}
                        onClick={() => {
                            setShowMenu(true);
                        }} />
                    <XMark className={`${classes.nav__close} ${showMenu ? classes.show__close__icon : ''} `}
                        onClick={closeMenuHandle}
                    />
                </div>
            </div>

            {/* <!-- =============== NAV MENU =============== --> */}

            <div className={`${classes.nav__menu} ${showMenu ? classes.show__menu : ''}`} >
                <ul className={classes.nav__list}>
                    {navItems.map((item: any, index) => {
                        return <li onClick={closeMenuHandle} key={`nav-key-${index}`}>
                            <Link to={item.path} className={classes.nav__link}>
                                {t(item.name)}
                            </Link>
                        </li>

                    })}
                    <li>
                        {width > 1119 ?
                            <LanguageMenuLg className={[classes.nav__link__btn, 'bttn_outlined'].join(' ')} />
                            :
                            <LanguageMenuSm setShowMenu={setShowMenu} className={[].join(' ')} />
                        }
                    </li>
                </ul>
            </div>
        </nav >
    </header >
    )
}


export default Nav;
